document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slideshow-component a[href*="#"], header a[href*="#"], menu-drawer a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetHref = this.getAttribute('href');

      // Check if href has a hash part
      if (targetHref && targetHref.includes('#')) {
        const hashPart = targetHref.split('#')[1];
        
        // Only proceed if there is text after #
        if (hashPart) {
          try {
            const targetSelector = '#' + hashPart;
            const target = document.querySelector(targetSelector);
            
            if (target) {
              e.preventDefault();
              const offset = 100;
              const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - offset;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          } catch (error) {
            // Ignore invalid selectors to prevent console errors
            console.log('Smooth scroll skipped for invalid selector');
          }
        } else {
            // If it's just "#" or link to another page, let it behave normally
            if(targetHref !== '#') {
                 window.location.href = this.href;
            }
        }
      }
    });
  });
});

window.addEventListener('load', () => {
  const hash = window.location.hash;
  
  // FIX: Pehle check karein ki hash khali to nahi hai
  if (hash && hash.length > 1) { 
    try {
      const target = document.querySelector(hash);
      if (target) {
        const offset = 100;
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } catch (e) {
      // Agar hash galat hai to error na dikhaye
      console.log('Initial scroll skipped'); 
    }
  }
});